import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Log } from 'src/app/_models/log';
import { DataResponse } from 'src/app/_classes/data-respone';
import { map } from 'rxjs/operators';
import { PedidoDeCompra } from 'src/app/_models/pedido-de-compra';
import { EmpresaECentroDestino } from 'src/app/_models/empresa-e-centro-destino';
import { RegistrarEtiquetaMarcopoloDTO } from 'src/app/_models/registar-etiqueta-marcopolo-dto';
import { EtiquetaMarcopolo } from 'src/app/_models/etiqueta-marcopolo';

@Injectable({
    providedIn: 'root'
})
export class EtiquetasMarcopoloService {

    constructor(private httpClient: HttpClient) { }

    registrarArquivoXMLMarcopolo(arquivoXML: HTMLInputElement): Observable<Response> {

        let arquivoXMLDto = new FormData();

        arquivoXMLDto.append('nomeArquivo', arquivoXML.files[0].name);
        arquivoXMLDto.append('ArquivoXML', arquivoXML.files[0]);

        return this.httpClient.post<DataResponse<any>>(`${environment.apiUrl}/etiquetas-marcopolo/registrar-arquivo-xml-marcopolo/`, arquivoXMLDto)
            .pipe(map(response => response ? response.data : null));
    }

    getPedidosDeCompraDisponiveis(numRegistros: number, pedidoCompra: string, itemPedidoDeCompra: string): Observable<PedidoDeCompra[]> {
        return this.httpClient.get<PedidoDeCompra[]>(`${environment.apiUrl}/etiquetas-marcopolo/get-pedidos-de-compra-disponiveis?numRegistros=${numRegistros}&pedidoCompra=${pedidoCompra}&itemPedidoDeCompra=${itemPedidoDeCompra}`);
    }

    getEmpresasECentrosDestino(): Observable<EmpresaECentroDestino[]> {
        return this.httpClient.get<EmpresaECentroDestino[]>(`${environment.apiUrl}/etiquetas-marcopolo/get-empresas-e-centros-destino`);
    }

    registrarEtiqueta(registrarEtiquetaMarcopoloDTO: RegistrarEtiquetaMarcopoloDTO): Observable<RegistrarEtiquetaMarcopoloDTO> {
        return this.httpClient.post<RegistrarEtiquetaMarcopoloDTO>(`${environment.apiUrl}/etiquetas-marcopolo/registrar-etiqueta`, registrarEtiquetaMarcopoloDTO);
    }

    getEtiquetasPorXMLBodyMarcopoloId(xmlBodyMarcopoloId: string): Observable<EtiquetaMarcopolo[]> {
        return this.httpClient.get<EtiquetaMarcopolo[]>(`${environment.apiUrl}/etiquetas-marcopolo/get-etiquetas-por-xmlbodymarcopoloid/${xmlBodyMarcopoloId}`);
    }
}
